export const WAREHOUSE_API_URL = ((warehouseApiUrl, reactAppEnv) => {
  if (window && window.__MODSY_WAREHOUSE_API_URL) {
    return window.__MODSY_WAREHOUSE_API_URL;
  }

  if (warehouseApiUrl) {
    return warehouseApiUrl;
  }

  if (reactAppEnv) {
    switch (reactAppEnv) {
      case 'dev':
        return 'https://www.warehouse.dev.modsy.com';
      case 'staging':
        return 'https://www.warehouse.staging.modsy.com';
      case 'prod':
        return 'https://www.warehouse.modsy.com';
      default:
        return warehouseApiUrl;
    }
  }
  return 'http://localhost:8000';
})(process.env.REACT_APP_WAREHOUSE_API_URL, process.env.REACT_APP_ENV);

export const ApiConfig = {
  get BASE () {
    return `${WAREHOUSE_API_URL}/warehouse/api`;
  },
  get ASSETS3D () {
    return `${this.BASE}/product3dassets`;
  },
  get GET_BESSIE_LINK () {
    return `${this.BASE}/v1/spaces/{space_id}/designs/{design_id}/start-bessie`;
  },
  get PRODUCTS () {
    return `${this.BASE}/products`;
  },
  get USERS () {
    return `${this.BASE}/users`;
  },
  get SPACE_INFO () {
    return `${this.BASE}/styleboardinfo`;
  },
  get MOODBOARD_PRODUCTS () {
    return `${this.BASE}/styleboard_products_snapshot`;
  },
  get USER_MOODBOARD_PRODUCTS () {
    return `${this.BASE}/user_moodboard_info`;
  },
  get RENDERS () {
    return `${this.BASE}/styleboardrenders`;
  },
  get DESIGNS () {
    return `${this.BASE}/v1/spaces`;
  },
  get CUSTOM_PROPS () {
    return `${this.BASE}/v1/space_custom_prop`;
  },
  get CREATE_EMPTY_CUSTOM_PROP () {
    return `${this.BASE}/v1/custom_prop/create_empty_custom_prop`;
  },
  get ADD_CUSTOM_PROP_TAG () {
    return `${this.BASE}/v1/space_custom_prop/{propID}/add_tag`;
  },
  get REMOVE_CUSTOM_PROP_TAG () {
    return `${this.BASE}/v1/space_custom_prop/{propID}/remove_tag`;
  },
  get UPLOAD_CUSTOM_PROP_IMAGE () {
    return `${this.BASE}/v1/custom_prop/{propID}/upload-image`;
  },
  get TAGS () {
    return `${this.BASE}/tags`;
  },
  get TAG_CATEGORIES () {
    return `${this.BASE}/tag_categories`;
  },
  get SOURCES () {
    return `${this.BASE}/sources`;
  },
  get STYLE_QUIZ () {
    return `${WAREHOUSE_API_URL}/api/survey_result`;
  },
  // legacy for django admin
  get GDRIVE_UPLOAD () {
    return `${this.BASE}/gdrive_upload`;
  },
  // endpoint used in Heidi
  get UPLOAD_TO_GDRIVE () {
    return `${this.BASE}/upload_to_gdrive`;
  },
  get SEND_USER_PHOTOS_APPROVED_EMAIL () {
    return `${this.BASE}/send_user_images_approved_email`;
  },
  get ORDERS () {
    return `${WAREHOUSE_API_URL}/api/payment/orders`;
  },
  get PAYMENT_CREDITS () {
    return `${WAREHOUSE_API_URL}/api/payment/credits`;
  },
  get PHOTOS_AND_MEASURMENTS () {
    return `${this.BASE}/dimension_dataset`;
  },
  get USER_IMAGES () {
    return `${this.BASE}/user_images`;
  },
  get USER_IMAGE_ADMIN_UPLOAD () {
    return `${this.BASE}/v1/{spaceID}/user_photo_upload`;
  },
  get USER_IMAGE_ADMIN_DELETE () {
    return `${this.BASE}/v1/{imageID}/admin_remove_photo`;
  },
  get STYLEBOARD () {
    return `${this.BASE}/styleboards`;
  },
  get ADMIN_STYLEBOARD () {
    return `${this.BASE}/admin/styleboards`;
  },
  get STYLEBOARD_ADDPRODUCT_FORMAT () {
    return `${this.STYLEBOARD}/{slug}/add_styleboard_product`;
  },
  get STYLEBOARD_ADDPRODUCT_CUSTOM () {
    return `${this.STYLEBOARD}/{slug}/add_styleboard_product`;
  },
  get SEARCH_FOR_PRODUCTS () {
    return `${this.BASE}/search_for_products`;
  },
  get USER_STYLEBOARD () {
    return `${this.BASE}/user/styleboard`;
  },
  get COPYSTYLEBOARDPRODUCTS () {
    return `${this.BASE}/copy_styleboard_products`;
  },
  get LOGIN () {
    return `${this.BASE}/login`;
  },
  get LOGOUT () {
    return `${this.BASE}/logout`;
  },
  get CHANGENAME () {
    return `${this.BASE}/user/change_name`;
  },
  get CREATE_STYLEBOARD () {
    return `${this.BASE}/create_styleboard`;
  },
  get GET_STYLEBOARD_AND_INFO_BASE () {
    return `${this.BASE}/styleboard_and_info`;
  },
  get GET_LATEST_STYLEBOARD_AND_INFO_BASE () {
    return `${this.BASE}/spaces/latest`;
  },
  get CHANGEPASSWORD () {
    return `${this.BASE}/user/change_password`;
  },
  get CHANGEEMAIL () {
    return `${this.BASE}/user/change_email`;
  },
  get ACTIVATE () {
    return `${this.BASE}/user/activate`;
  },
  get RESET_PASSWORD () {
    return `${this.BASE}/user/reset-password`;
  },
  get PAYMENTMETA () {
    return `${this.PAYMENT}/get_metadata`;
  },
  get PLACEORDER () {
    return `${this.PAYMENT}/place_order`;
  },
  get UPDATECART () {
    return `${this.PAYMENT}/shopping_cart/current`;
  },
  get CHANGE_RESET () {
    return `${this.BASE}/user/change-reset`;
  },
  get WELCOME_DATA () {
    return `${this.BASE}/user/get-welcome-data`;
  },
  get WELCOME_CONTINUE () {
    return `${this.BASE}/user/welcome-continue`;
  },
  get SPACE_LIST () {
    return `${this.BASE}/spacelist`;
  },
  get GET_SPACE () {
    return `${this.BASE}/spaces/{pk}`;
  },
  get GET_ALTERNATIVES () {
    return `${this.BASE}/spaces/{spaceID}/alternatives/{productID}`;
  },
  get SEARCH_ALTERNATIVES () {
    return `${this.BASE}/spaces/products/search`;
  },
  get SET_FLAGS () {
    return `${this.BASE}/user/set-account-flags`;
  },
  get GET_ASSET_OPTIONS () {
    return `${this.BASE}/asset_options`;
  },
  get SET_ASSET_OPTIONS () {
    return `${this.BASE}/set_asset_options`;
  },
  get SPACE_SET_REMINDER () {
    return `${this.BASE}/spaces/{spaceID}/dashboard/set-reminder`;
  },
  get SPACE_SET_CURRENT_TAB () {
    return `${this.BASE}/spaces/{spaceID}/dashboard/set-current-tab`;
  },
  get UPLOAD_PHOTOS () {
    return `${this.BASE}/spaces/{spaceID}/dashboard/submit-photos`;
  },
  get REMOVE_PHOTOS () {
    return `${this.BASE}/spaces/{spaceID}/dashboard/remove-photos`;
  },
  get SUBMIT_MEASUREMENT () {
    return `${this.BASE}/spaces/{spaceID}/dashboard/submit-measurement`;
  },
  get UPDATE_SPACE_FLAGS () {
    return `${this.BASE}/spaces/{spaceID}/set-space-flags`;
  },
  SEND_ASSISTANCE_EMAIL (spaceId) {
    return `${this.BASE}/spaces/${spaceId}/send_assistance`;
  },
  SAVE_ONBOARDING_INFO: spaceId =>
    [this.BASE, 'spaces', spaceId, 'info'].join('/'),
  APPLY_PROMO_CODE: () => `${WAREHOUSE_API_URL}/api/payment/apply_coupon`,
  get SEARCH_PRODUCTS () {
    return `${this.BASE}/spaces/products/search`;
  },
  get SUBMIT_MOODBOARD_COMMENTS () {
    return `${this.BASE}/spaces/{spaceID}/submit_customer_notes`;
  },
  get SAVE_MOODBOARD () {
    return `${this.BASE}/save_moodboard/`;
  },
  SUBMIT_MOODBOARD (spaceID) {
    return `${this.BASE}/spaces/${spaceID}/submit_moodboard`;
  },
  get FETCH_MOODBOARD () {
    return `${this.BASE}/fetch_moodboard/`;
  },
  get FETCH_CATEGORIES () {
    return `${this.BASE}/categories`;
  },
  get FETCH_STYLE_PRODUCTS () {
    return `${this.BASE}/api/style-products/`;
  },
  get GET_COLLECTIONS () {
    return `${this.BASE}/collections`;
  },
  get SUBMIT_CUSTOM_PROP () {
    return `${this.BASE}/v1/custom_prop/{id}/submit`;
  },
  APPROVE_CUSTOM_PROP (id) {
    return `${this.BASE}/v1/custom_prop/${id}/approve`;
  },
  get PAYMENT () {
    return `${WAREHOUSE_API_URL}/api/payment`;
  },
  get USERAUTH () {
    return `${WAREHOUSE_API_URL}/api/users/info`;
  },
  get USERSIGNUP () {
    return `${WAREHOUSE_API_URL}/api/users/signup`;
  },
  get STYLE_QUIZ_ROOMS () {
    return `${WAREHOUSE_API_URL}/api/rooms_nested`;
  },
  get SUBMIT_STYLE_QUIZ () {
    return `${WAREHOUSE_API_URL}/api/survey_result`;
  },
  get REQUEST_TOKEN () {
    return `${this.BASE}/internal-api-auth-token`;
  },
  get USERS_UPLOAD_IMAGE () {
    return `${WAREHOUSE_API_URL}/api/users/upload-image`;
  },
  SET_PRODUCT_FAVORITE (spaceID) {
    return `${this.BASE}/v2/spaces/${spaceID}/favorite_products`;
  },
};

export const OldAdminConfig = {
  BASE: `${WAREHOUSE_API_URL}/admin/warehouse`,
  get PRODUCT () {
    return `${this.BASE}/product`;
  },
  get USER () {
    return `${this.BASE}/user`;
  },
  get STYLEBOARD () {
    return `${this.BASE}/styleboard`;
  }
};

export const Config = {
  BASE: '',
  get INTRO () {
    return `${this.BASE}/studio`;
  },
  get SPACE () {
    return `${this.INTRO}/space`;
  }
};

export const StaticConfig = {
  BASE: 'https://s3-us-west-2.amazonaws.com/modsy',
  get PAYPAL_CLIENT_ID_SANDBOX(){
    return "AcZlM7eqXDyddOL90fdrZXcyKW0Qh17oaLTO-7gnDUPaKPaPVCnJ4eLyUlqnYre6DbozqknlAO8KNB8E"
  },
  get PAYPAL_CLIENT_ID_PRODUCTION(){
    return "AdsGnZ8S-2YsFOK_DqtN4BGIZOxehOgjlhDEEpsTWBnej-LQjqf8-DiuQKaKYtcudTVLMKvakPa-G5qu"
  },
  get SPINNER () {
    return this.BASE;
  },
  get MODSY_LOGO () {
    return `${this.BASE}/images/icons/apple-icon-76x76.png`;
  },
  get LOADER_GIF () {
    return `${this.BASE}/images/ajax-loader.gif`;
  },
  get CLOSE_X () {
    return `${this.BASE}/images/close-icon.png`;
  },
  get CART_ICON () {
    return `${this.BASE}/images/cart-icon.png`;
  },
  get PAYMENT_SUCCESS_ICON () {
    return `${this.BASE}/images/payment-success.png`;
  },
  get HEART () {
    return `${this.BASE}/images/heart.png`;
  },
  get EMPTY_CART () {
    return `${this.BASE}/images/empty-cart.png`;
  },
  get ARROW_DOWN () {
    return `${this.BASE}/images/arrow-down.png`;
  },
  get ARROW_RIGHT () {
    return `${this.BASE}/images/arrow-right.png`;
  },
  get UPGRADE_ICON () {
    return `${this.BASE}/images/upgrade-icon.png`;
  },
  get SUCCESS () {
    return `${this.BASE}/images/success-img.png`;
  },
  get SHOPPING_TAG () {
    return `${this.BASE}/images/shopping-tag.svg`;
  },
  get STAR_ICON () {
    return `${this.BASE}/images/star-icon.svg`;
  },
  DASH_COMPLETE_ICON: require('../static/images/dash-complete-icon.svg'),
  DASH_STYLE_ICON: require('../static/images/dash-style-icon.svg'),
  DASH_PHOTOS_ICON: require('../static/images/dash-photos-icon.svg'),
  DASH_MOODBOARD_ICON: require('../static/images/dash-moodboard-icon.svg'),
  DASH_MENU_ICON: require('../static/images/dash-menu-icon.svg'),
  DASH_MENU_ARROW: require('../static/images/menu-arrow.svg'),
  DASH_MOBILE_CHECK: require('../static/images/dash-mobile-check.svg'),
  DASH_TIP_ICON: require('../static/images/dash-tip-icon.svg'),
  DASH_WARNING_ICON: require('../static/images/dash-warning-icon.svg'),
  DASH_MEASURE_ICON: require('../static/images/dash-measure-icon.svg'),
  DASH_PENDING_ICON: require('../static/images/dash-pending-icon.svg'),
  DASH_BLUE_TIP: require('../static/images/blue-tip.svg'),
  DASH_ORANGE_PHOTOS: require('../static/images/orange-photos-icon.svg'),
  DASH_ROTATE_TIP: require('../static/images/rotate-tip.png'),
  DASH_LIGHTBULB: require('../static/images/lightbulb.svg'),
  DASH_CURTAINS: require('../static/images/curtains-tip.svg'),
  PHOTOS_CORNERS: require('../static/images/photos-corners.jpg'),
  PHOTOS_CENTER: require('../static/images/photos-center.jpg'),
  MOODBOARD_ICON: require('../static/images/moodboard-icon.svg'),
  DISCUSSION_ICON: require('../static/images/discussion-icon.svg'),
  DISCUSSION_ICON_GREY: require('../static/images/discussion-icon-grey.svg'),
  RESET_MOODBOARD_ICON: require('../static/images/refresh-moodboard-icon.svg'),
  PRODUCT_DELETE: require('../static/images/product-delete-icon.svg'),
  SMALL_LOGO: require('../static/images/small-modsy-logo.svg'),
  BLUE_CHECK: require('../static/images/blue-check.svg'),
  GUIDE_RINGS: require('../static/images/guide-rings.svg'),
  FORM_ERROR: require('../static/images/form-error.svg')
};
